import React from "react";
import EditIcon from "../assets/icons/edit-icon.svg";
import DeleteIcon from "../assets/icons/delete-icon.svg";
import "../styles/components/no-image_item.css";

const NoImageItem = ({ title, onEdit, onDelete }) => {
    return (
        <div className="no-image_item">
            <h3 className="no-image_item-title">{title}</h3>
            <div className="no-image_item-actions">
                {onEdit && (
                    <button className="item-btn item-edit" onClick={onEdit}>
                        <img src={EditIcon} alt="Edit" />
                    </button>
                )}
                <button className="item-btn item-delete" onClick={onDelete}>
                    <img src={DeleteIcon} alt="Delete" />
                </button>
            </div>
        </div>
    );
};

export default NoImageItem;
